import type { ContentObjectDetailDataObject } from '../service';
import {
  type ActivityContentObjectDetail,
  type EventContentObjectDetail,
  type GivingContentObjectDetail,
  type KudoContentObjectDetail,
  type PollContentObjectDetail,
  type PostContentObjectDetail,
  type VideoContentObject,
  type WithingsOrderPostContentObjectDetail,
  createActivityContentObjectDetail,
  createEventContentObject,
  createGivingContentObjectDetail,
  createKudoContentObjectDetail,
  createPollContentObjectDetail,
  createPostContentObjectDetail,
  createVideoContentObject,
  createWithingsOrderPostContentObjectDetail,
} from './entity-type-content-objects';

export type ContentObjectDetail =
  | ActivityContentObjectDetail
  | EventContentObjectDetail
  | GivingContentObjectDetail
  | KudoContentObjectDetail
  | PollContentObjectDetail
  | PostContentObjectDetail
  | VideoContentObject
  | WithingsOrderPostContentObjectDetail;

export type NonEventContentObjectDetail = Exclude<ContentObjectDetail, EventContentObjectDetail>;

export const createContentObjectDetail = (data: ContentObjectDetailDataObject): ContentObjectDetail => {
  switch (data.type) {
    case 'activity':
      return createActivityContentObjectDetail(data);
    case 'event':
      return createEventContentObject(data);
    case 'giving':
      return createGivingContentObjectDetail(data);
    case 'kudo':
      return createKudoContentObjectDetail(data);
    case 'poll':
      return createPollContentObjectDetail(data);
    case 'post':
      return createPostContentObjectDetail(data);
    case 'video':
      return createVideoContentObject(data);
    case 'withings_order_post':
      return createWithingsOrderPostContentObjectDetail(data);
  }
};
